export default __webpack_public_path__ + "static/media/bash.423df693.svg";